import axiosInstance from 'src/utils/axios';
import {
  AviationStatsResponse,
  FlightsResponse,
  GenericStatsQueryParams,
  ImpactStatsQueryParams,
  ImpactStatsResponse,
  GetMerchantEmployeeQueryParams,
  MerchantEmployeeResponse,
  JourneyStatsResponse,
  PurchasesByMerchantResponse,
  PurchasesByMerchantQueryParams,
  EngagementSummaryQueryParams,
  EngagementSummaryResponse,
  EngagementDisctributionResponse,
} from './types.api';

//
//

const BASE_URL = 'reports';

//
// Merchant Employees API

export const getMerchantEmployeesAPI = async (
  params: GetMerchantEmployeeQueryParams
): Promise<MerchantEmployeeResponse> => {
  const response = await axiosInstance.get<MerchantEmployeeResponse>(`${BASE_URL}/customers/v1`, {
    params,
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//
// Impact Stats API

export const getImpactStatsAPI = async (
  params: ImpactStatsQueryParams
): Promise<ImpactStatsResponse> => {
  const response = await axiosInstance.get<ImpactStatsResponse>(`${BASE_URL}/impact/v1`, {
    params,
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//
// Aviation Stats API

export const getAviationStatsAPI = async (
  params: GenericStatsQueryParams
): Promise<AviationStatsResponse> => {
  const response = await axiosInstance.get<AviationStatsResponse>(`${BASE_URL}/aviation/v1`, {
    params,
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//
// Journey Stats API

export const getJourneyStatsAPI = async (
  params: GenericStatsQueryParams
): Promise<JourneyStatsResponse> => {
  const response = await axiosInstance.get<JourneyStatsResponse>(`${BASE_URL}/journey/v1`, {
    params,
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//
// Flights API

export const getFlightsAPI = async (params: GenericStatsQueryParams): Promise<FlightsResponse> => {
  const response = await axiosInstance.get<FlightsResponse>(`${BASE_URL}/aviation/v1/flights`, {
    params,
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//
// Purchases by Merchant API

export const getPurchasesByMerchantCodeAPI = async (
  params: PurchasesByMerchantQueryParams
): Promise<PurchasesByMerchantResponse> => {
  const response = await axiosInstance.get<PurchasesByMerchantResponse>(`${BASE_URL}/purchases/v1`, {
    params,
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getEngagementSummaryAPI = async (
  params: EngagementSummaryQueryParams
): Promise<EngagementSummaryResponse> => {
  const response = await axiosInstance.get<EngagementSummaryResponse>(`${BASE_URL}/engagement/v1/summary`, {
    params,
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getEngagementDistributionAPI = async (
  params: EngagementSummaryQueryParams
): Promise<EngagementDisctributionResponse> => {
  const response = await axiosInstance.get<EngagementDisctributionResponse>(`${BASE_URL}/engagement/v1/distribution`, {
    params,
    paramsSerializer: { indexes: null },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};
